import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';
import { FilterDashboardVideoTutoriel } from '../utils/type';

import Filter from './Filter/Filter';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalCount: number;
  refreshDashboard: () => void;
  setFilter: (value: Partial<FilterDashboardVideoTutoriel>) => void;
  filter: Partial<FilterDashboardVideoTutoriel>;
}

export function DashboardHeader({
  totalCount,
  refreshDashboard,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const modalCreation = useModal();
  const countString = `${totalCount} vidéo${totalCount > 1 ? 's' : ''} trouvée${
    totalCount > 1 ? 's' : ''
  }`;

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer une vidéo
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
